/**
 * Convert a stored E.164 phone (`+17145551234`) to a human-readable form
 * for tables and detail pages. The underlying value sent to Twilio remains
 * the original E.164 string — this is display-only.
 */
const US_RE = /^\+1(\d{3})(\d{3})(\d{4})$/;

export function formatPhoneDisplay(e164) {
    if (!e164) return "";
    const s = String(e164);
    const m = s.match(US_RE);
    if (m) return `(${m[1]}) ${m[2]}-${m[3]}`;
    return s; // non-US — show as stored
}

/**
 * Pick the best phone value off a lead — phone_e164 first (canonical),
 * then legacy `phone`, then raw. Returns "" if nothing usable.
 */
export function leadPhoneDisplay(lead) {
    if (!lead) return "";
    const canonical = lead.phone_e164 || lead.phone;
    if (canonical) return formatPhoneDisplay(canonical);
    return lead.phone_raw || "";
}
